export default __webpack_public_path__ + "static/media/Bottom.772467ac.svg";